module.exports = "/images/cv.svg?fe1d2d93a2eca1e086f3c0f28b849da4";